// src/pages/News.js
import React from "react";

const News = () => {
  return (
    <div className="container mt-5">
      <h2>Notícias e Atualizações</h2>
      <div className="news-item">
        <h5>Notícia 1</h5>
        <p>
          Detalhes sobre a primeira notícia. Fique por dentro de tudo que
          acontece em nossa empresa e em nosso setor.
        </p>
      </div>
      <div className="news-item">
        <h5>Notícia 2</h5>
        <p>
          Detalhes sobre a segunda notícia. Acompanhe as últimas
          atualizações.
        </p>
      </div>
      <div className="news-item">
        <h5>Notícia 3</h5>
        <p>
          Detalhes sobre a terceira notícia. Sempre trazendo novidades
          interessantes.
        </p>
      </div>
    </div>
  );
};

export default News;
